<template>
  <div class="modal">
  </div>
</template>

<script>
export default {
  name: 'Modal',
  props: [
  ],
  data: function () {
    return {
    }
  },
}
</script>


<style scoped>
.modal {
  background-color: rgba(0,0,0,0.6);
  bottom: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 1200;
}
</style>
